var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjects2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 325,
    viewBox: "0 0 343 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.979 43.3267H191.734C189.128 43.3267 186.547 42.8255 184.139 41.8516C181.731 40.8777 179.543 39.4502 177.7 37.6507C175.857 35.8511 174.395 33.7148 173.397 31.3635C172.4 29.0123 171.886 26.4923 171.886 23.9474L171.82 20.6162H215.76L215.827 23.9474C215.827 29.0871 213.736 34.0163 210.014 37.6507C206.292 41.285 201.243 43.3267 195.979 43.3267Z",
    fill: "#FE6571"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.077 23.0023C182.966 20.6152 179.243 10.5023 185.589 10.3613C190.4 10.2528 192.868 18.5427 193.79 20.6369C194.203 18.0838 195.161 15.6439 196.601 13.4754C197.326 12.3561 198.332 11.4371 199.524 10.8061C200.12 10.4978 200.78 10.3259 201.454 10.3033C202.127 10.2808 202.798 10.4082 203.414 10.6759C204.107 11.0795 204.685 11.6468 205.095 12.3256C205.504 13.0044 205.733 13.773 205.759 14.5605C205.762 16.161 205.484 17.7503 204.936 19.2588C206.548 17.284 208.503 15.1573 211.093 15.0271C211.684 14.9738 212.277 15.0988 212.793 15.3851C213.305 15.7807 213.663 16.3352 213.809 16.9567C213.954 17.5782 213.878 18.2296 213.593 18.8031C213.018 19.943 212.177 20.9353 211.137 21.7003",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M311.976 57.2593H307.72C305.115 57.2593 302.536 56.7583 300.129 55.7849C297.722 54.8116 295.536 53.3849 293.694 51.5863C291.852 49.7878 290.39 47.6526 289.394 45.3027C288.397 42.9529 287.884 40.4342 287.884 37.8907L287.817 34.5596H331.746L331.813 37.8907C331.813 43.0276 329.723 47.954 326.003 51.5863C322.283 55.2187 317.237 57.2593 311.976 57.2593Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M297.952 37.9338C283.672 15.6464 283.605 2.62557 286.706 1.37774C295.518 -2.18129 299.93 20.1929 303.675 35.5466C304.309 28.7975 307.609 19.3465 311.454 20.1929C317.4 21.5058 314.299 34.3964 314.355 36.903C320.923 21.8313 324.357 21.3756 326.29 22.2979C329.624 23.8821 325.357 34.4181 322.49 38.9103",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M313.455 315.125H309.199C306.594 315.125 304.014 314.624 301.608 313.651C299.201 312.678 297.014 311.251 295.172 309.452C293.33 307.654 291.869 305.519 290.872 303.169C289.875 300.819 289.362 298.3 289.362 295.757L289.295 274.663H333.225L333.292 295.757C333.292 298.3 332.778 300.819 331.782 303.169C330.785 305.519 329.324 307.654 327.482 309.452C325.64 311.251 323.453 312.678 321.046 313.651C318.639 314.624 316.06 315.125 313.455 315.125Z",
    fill: "#FE6571"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M300.975 279.569C295.041 267.112 291.485 227.486 297.53 225.674C302.775 224.122 309.165 262.273 309.565 275.12C309.699 266.841 310.832 226.292 318.811 225.207C326.435 224.22 319.189 263.043 316.655 277.16C319.261 266.812 322.936 256.749 327.624 247.125C335.058 232.651 338.948 236.275 337.625 241.494C334.725 253.137 329.669 268.447 324.39 279.265",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M298.53 272.547C298.53 272.645 292.062 262.662 289.762 260.612C289.399 260.209 288.911 259.935 288.373 259.83C287.262 259.733 286.561 261.067 286.55 262.174C286.55 264.236 287.662 266.124 288.773 267.892C291.684 272.634 294.629 277.408 298.508 281.423",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M213.97 252.917L163.083 256.496L166.748 306.183L217.636 302.604L213.97 252.917Z",
    fill: "#FFCC00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.619 255.446C165.405 255.446 167.664 253.241 167.664 250.52C167.664 247.799 165.405 245.594 162.619 245.594C159.832 245.594 157.573 247.799 157.573 250.52C157.573 253.241 159.832 255.446 162.619 255.446Z",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.941 259.311L165.341 254.656",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.787 266.093C170.787 266.093 201.436 263.542 204.626 263.661",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.553 280.557C172.553 280.557 176.543 278.061 179.221 279.548C181.899 281.035 195.024 278.701 195.024 278.701",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M180.244 299.197C180.244 299.197 172.954 287.532 178.499 286.74C181.355 286.339 181.833 290.874 181.833 290.874C181.833 290.874 185.956 285.286 188.623 288.986C190.723 291.894 180.244 299.197 180.244 299.197Z",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.387 273.535C171.387 273.535 188.612 272.504 189.312 272.33",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6052 220.879L62.8838 214.829L56.6871 249.708L92.4086 255.758L98.6052 220.879Z",
    fill: "#FFCC00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1143 223.849L91.7296 227.95",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3472 229.938L78.1604 231.989",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8606 280.936H23.7285V325H83.8606V280.936Z",
    fill: "#3098F3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6641 277.681C36.6641 279.417 36.6641 281.153 36.6641 282.889",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.878 277.441C53.0112 279.167 52.8114 280.903 52.8003 282.639",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3589 277.767C70.5088 279.304 70.5088 280.852 70.3589 282.389",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6968 298.709H74.1591",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6968 308.778H74.1591",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5098 316.221V289.93",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2998 316.221V289.93",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0913 316.221V289.93",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1604 288.629H30.3862V318.772H76.1604V288.629Z",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8199 316.656C37.7532 316.656 39.3205 315.126 39.3205 313.238C39.3205 311.351 37.7532 309.82 35.8199 309.82C33.8866 309.82 32.3193 311.351 32.3193 313.238C32.3193 315.126 33.8866 316.656 35.8199 316.656Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9576 297.233C60.8909 297.233 62.4582 295.703 62.4582 293.815C62.4582 291.928 60.8909 290.397 58.9576 290.397C57.0243 290.397 55.457 291.928 55.457 293.815C55.457 295.703 57.0243 297.233 58.9576 297.233Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3164 214.762L0 228.178L13.7103 263.648L50.0267 250.233L36.3164 214.762Z",
    fill: "#FE6571"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0084 222.039L7.49157 230.347C5.99308 230.899 5.23735 232.534 5.8036 233.997L7.49669 238.372C8.06294 239.835 9.73673 240.573 11.2352 240.02L33.752 231.712C35.2505 231.16 36.0063 229.525 35.44 228.062L33.7469 223.688C33.1807 222.224 31.5069 221.486 30.0084 222.039Z",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9712 232.357L28.8964 226.118",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7383 235.776L16.9058 233.974",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3496 244.726L36.32 236.74",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6844 21.5814L89.7509 18.0766C89.6318 17.6218 89.3843 17.2087 89.0365 16.8845C88.6887 16.5603 88.2547 16.338 87.7839 16.2429L55.9453 10.2207C54.9182 10.0266 53.8552 10.1322 52.8893 10.5245L33.5861 19.5198C33.0976 18.1089 32.0656 16.9393 30.7089 16.2587C29.3522 15.5781 27.7774 15.4401 26.3182 15.8739L21.273 17.3713C20.5338 17.5896 19.846 17.9483 19.249 18.4266C18.6521 18.905 18.1577 19.4938 17.7943 20.1591C17.4309 20.8244 17.2056 21.5533 17.1312 22.3038C17.0569 23.0543 17.1351 23.8118 17.3612 24.5328L25.2292 49.7933C25.4516 50.5148 25.8177 51.1864 26.3064 51.7695C26.7951 52.3527 27.3968 52.836 28.0771 53.1918C28.7573 53.5476 29.5028 53.7689 30.2708 53.843C31.0388 53.9171 31.8142 53.8425 32.5526 53.6236L37.609 52.1262C38.8037 51.7713 39.8517 51.0541 40.601 50.0787C41.3502 49.1032 41.7619 47.9201 41.7763 46.7008L62.2241 45.6808C63.3149 45.6135 64.3548 45.2066 65.1913 44.5198L89.8842 24.1205C90.2468 23.8122 90.5138 23.4111 90.6552 22.9624C90.7966 22.5137 90.8067 22.0354 90.6844 21.5814Z",
    fill: "#F2EAE2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2729 20.04L64.9688 26.4637",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.857 31.662C63.2015 31.662 65.1021 29.8062 65.1021 27.517C65.1021 25.2278 63.2015 23.3721 60.857 23.3721C58.5124 23.3721 56.6118 25.2278 56.6118 27.517C56.6118 29.8062 58.5124 31.662 60.857 31.662Z",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M343 108.066L288.104 106.157L285.53 176.707L340.426 178.616L343 108.066Z",
    fill: "#F2EAE2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M295.519 163.14C299.223 150.337 302.927 137.544 306.631 124.761C306.798 123.878 307.24 123.067 307.898 122.439C308.707 121.956 309.656 121.746 310.599 121.843L320.378 121.767",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M296.762 164.236C298.585 164.062 304.708 164.236 304.708 164.236C304.708 164.236 309.709 148.22 310.042 148.025C310.376 147.829 317.821 147.938 317.821 148.22C318.366 153.96 319.477 159.646 319.833 163.617C323.208 163.941 326.598 164.089 329.99 164.062C330.201 163.845 330.068 162.912 329.99 162.619C329.101 157.476 324.522 133.181 323.189 129.546",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M311.154 140.744C311.154 140.744 315.688 140.95 316.889 140.928C317.144 140.928 314.266 128.602 314.266 128.602L311.154 140.744Z",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M168.508 134.712H212.249V154.373C212.249 156.906 211.738 159.413 210.746 161.752C209.753 164.092 208.299 166.217 206.465 168.008C204.631 169.798 202.454 171.218 200.058 172.187C197.662 173.156 195.094 173.655 192.501 173.655H188.278C185.685 173.655 183.117 173.156 180.721 172.187C178.325 171.218 176.148 169.798 174.314 168.008C172.481 166.217 171.026 164.092 170.034 161.752C169.041 159.413 168.531 156.906 168.531 154.373V134.712H168.508Z",
    fill: "#3098F3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M187.688 170.812H193.045C196.72 170.812 200.245 172.237 202.844 174.775C205.443 177.312 206.903 180.754 206.903 184.342V191.309H173.831V184.375C173.826 182.595 174.181 180.832 174.876 179.187C175.57 177.541 176.59 176.046 177.878 174.786C179.165 173.526 180.694 172.527 182.378 171.845C184.061 171.163 185.866 170.812 187.688 170.812V170.812Z",
    fill: "#3098F3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M176.388 106.108C181.274 115.799 184.817 126.082 186.923 136.686",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M190.912 135.732C192.968 122.212 202.503 104.623 205.581 101.846",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M183.133 134.44C180.755 131.546 178.506 128.559 176.387 125.477C174.998 123.448 171.586 117.621 174.309 116.938C175.92 116.536 178.254 119.64 179.766 121.452C175.443 115.299 171.297 108.529 171.12 101.063C171.064 98.2854 171.942 95.2472 174.398 93.8584C177.487 92.1114 180.455 95.1062 181.899 97.5367C186.278 104.969 185.3 110.362 186.289 118.88C186.511 118.196 186.644 116.124 187.722 116.113C191.201 116.113 189.856 131.131 189.034 134.331",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M191.045 117.111C192.234 111.491 195.301 98.5458 199.191 98.7303C200.88 98.8062 200.924 101.486 200.769 102.224C201.516 99.8665 202.806 97.707 204.539 95.9109C206.273 94.1148 208.404 92.7297 210.77 91.8618C211.311 91.6132 211.901 91.4844 212.498 91.4844C213.096 91.4844 213.686 91.6132 214.227 91.8618C214.664 92.1734 215.008 92.5927 215.225 93.077C215.442 93.5612 215.523 94.093 215.46 94.6179C215.317 95.6602 214.97 96.6659 214.438 97.5801C212.119 101.766 209.559 105.82 206.77 109.722C209.837 107.66 211.215 107.194 212.782 107.454C213.425 107.617 213.993 107.985 214.396 108.501C214.799 109.016 215.013 109.649 215.004 110.297C214.959 111.582 214.577 112.833 213.893 113.932C211.373 118.471 207.95 122.474 203.825 125.705C205.003 125.879 206.503 124.859 207.236 125.781C207.407 126.027 207.492 126.32 207.481 126.617C207.398 127.264 207.178 127.887 206.836 128.448C206.493 129.008 206.036 129.493 205.492 129.872C202.97 132.093 200.09 133.893 196.968 135.2",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2251 153.255V103.938H31.3079V153.255H68.2251Z",
    fill: "#FE6571"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2021 147.744V109.137H36.3088V147.744H63.2021Z",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1213 130.979C50.8836 130.979 53.9335 128.001 53.9335 124.327C53.9335 120.654 50.8836 117.676 47.1213 117.676C43.359 117.676 40.3091 120.654 40.3091 124.327C40.3091 128.001 43.359 130.979 47.1213 130.979Z",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0996 139.03C50.0996 137.689 50.6452 136.403 51.6164 135.455C52.5876 134.506 53.9048 133.974 55.2782 133.974C56.6517 133.974 57.9689 134.506 58.9401 135.455C59.9113 136.403 60.4569 137.689 60.4569 139.03",
    stroke: "#092C4E",
    strokeWidth: 0.988166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects2);
export default __webpack_public_path__ + "static/media/objects2.dce66cdf65363f78a563abcf8b2e97c7.svg";
export { ForwardRef as ReactComponent };